import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_SAP_OPENAI_DESCRIPTIONS = createFcmConfig('sap_openai_descriptions', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
